var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"1"}}),_c('MobileNavBar',{attrs:{"currentActive":0}}),_c('TopBanner'),_c('Map'),_c('ProductShow'),_c('MobileProductShow'),_c('BrandAndNews'),_c('Milestone'),_c('CallMe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }